"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekDay = void 0;
/**
 * Days of the week
 */
var WeekDay;
(function (WeekDay) {
    WeekDay["MONDAY"] = "MONDAY";
    WeekDay["TUESDAY"] = "TUESDAY";
    WeekDay["WEDNESDAY"] = "WEDNESDAY";
    WeekDay["THURSDAY"] = "THURSDAY";
    WeekDay["FRIDAY"] = "FRIDAY";
})(WeekDay = exports.WeekDay || (exports.WeekDay = {}));
//# sourceMappingURL=WeekDay.js.map